// extracted by mini-css-extract-plugin
export default {"container":"NotFound_container__8fHe5","voltar":"NotFound_voltar__GgKVJ"};